import env from 'enviro';
export { createBusinessUnitSelectChangeTracker } from 'ui-business-units-lib/utils/tracking';
import { Tracker } from 'usage-tracker-core';

/**
 * Clones @tracker from host applications to send events on framework-listing-lib's behalf.
 * @param tracker
 */
export function setupTracker(tracker?: Tracker) {
  if (!tracker) {
    if (env.isQa()) {
      console.error(
        "[framework-listing-lib] tracker was not set by host application and we won't be able to track events."
      );
    }
    return undefined;
  }

  return tracker.clone({
    standalone: true,
    preserveTrackerProperties: false,
  });
}
